import { createApp } from "vue"
import { createI18n } from "vue-i18n"

export function loadLocaleMessages(language) {
  if (!i18n.global.save) {
    i18n.global.save = {};
    i18n.global.locale = language;
    return axios({ method: "GET", "url": `${process.env.VUE_APP_API_ENDPOINT}/translations` }).then(result => {
      i18n.global.save = result.data;
      i18n.global.setLocaleMessage(language, result.data[language]);
    }, error => {
      console.error(error);
    });
  } else {
    i18n.global.setLocaleMessage(language, i18n.global.save[language]);
    return Promise.resolve();
  }
}

const i18n = createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {},
  sync: false,
})

export default i18n;